import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import PrivacyJSON from "@jsons/privacyPolicy.json"
import PrivacyPolicy from "@pages/PrivacyPolicy/PrivacyPolicy"
import React from "react"

type Props = {}

const privacyPolicy = (props: Props): JSX.Element => {
	const PrivacySections = getTranslatedPageData(PrivacyJSON, true, true)

	return (
		<>
			<HeadMeta
				meta={PrivacySections.metaData}
				customPath={"/privacy-policy"}
			/>

			<PrivacyPolicy
				data={getValueOrThrow(PrivacySections.AdvancedSideAsset?.[0])}
			/>
		</>
	)
}

export default privacyPolicy
